<template>
    <div class="row">
        <div class="col-lg-12">
            <div class="oneway_search_form">
                <form action="#!">
                    <div class="row">
                        <div class="col-lg-3 col-md-6 col-sm-12 col-12 relative">
                            <div class="flight_Search_boxed">
                                <p>{{ $t('From') }}</p>
                                <input type="text" :value="main_airport.code" :placeholder="$t('City or Airport')"
                                    readonly>
                                <span class="departure_name">
                                    {{
                                        main_airport[this.$i18n.locale + '_name']
                                    }}
                                </span>
                                <div class="plan_icon_posation">
                                    <i class="fas fa-plane-departure"></i>
                                </div>
                            </div>
                            <div v-if="0" class="form-group check-companion">
                                <label class="form-check-label">
                                    <span class="area_flex_one">
                                        <div class="ripple-checkbox-primary">
                                            <input class="inp-cbx" id="booking-companion-cheapest-1" type="checkbox"
                                                v-model="cheapest" style="display: none">
                                            <label class="cbx" for="booking-companion-cheapest-1">
                                                <span>
                                                    <svg width="12px" height="10px" viewBox="0 0 12 10">
                                                        <polyline points="1.5 6 4.5 9 10.5 1">
                                                        </polyline>
                                                    </svg>
                                                </span>
                                            </label>
                                        </div>
                                        <span class="p-0 pl-2 pr-2">
                                            {{ $t('View the cheapest flights') }}
                                        </span>
                                    </span>
                                </label>
                            </div>
                             <div v-if="is_admin" class="form-group check-companion">
                                <label class="form-check-label">
                                    <span class="area_flex_one">
                                        <div class="ripple-checkbox-primary">
                                            <input class="inp-cbx" id="booking-companion-unique-1" type="checkbox"
                                                v-model="unique" style="display: none">
                                            <label class="cbx" for="booking-companion-unique-1">
                                                <span>
                                                    <svg width="12px" height="10px" viewBox="0 0 12 10">
                                                        <polyline points="1.5 6 4.5 9 10.5 1">
                                                        </polyline>
                                                    </svg>
                                                </span>
                                            </label>
                                        </div>
                                        <span class="p-0 pl-2 pr-2">
                                            {{ $t('View flights without duplicates') }}
                                        </span>
                                    </span>
                                </label>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-12 col-12 relative">
                            <div class="flight_Search_boxed">
                                <p>{{ $t('To') }}</p>
                                <input type="text" v-model="arrival" @input="handle_airports_search_oneway"
                                    :placeholder="$t('City or Airport')" autocomplete="off">
                                <span class="arrival_name">
                                    {{ arrival_name }}
                                </span>
                                <div class="plan_icon_posation">
                                    <i class="fas fa-plane-arrival"></i>
                                </div>
                                <div class="range_plan">
                                    <i class="fas fa-exchange-alt"></i>
                                </div>
                            </div>
                            <ul v-if="is_searching" tabindex="0"
                                class="ui-id-1 ui-menu ui-widget ui-widget-content ui-autocomplete ui-front"
                                style="top: 110px;z-index: 1060;left: 0px;text-align: initial;right: 0;">
                                <li class="fl-route-list ui-autocomplete-category ui-state-disabled ui-menu-item"
                                    aria-disabled="true">
                                    <a class="fl-routes ui-menu-item-wrapper" id="ui-id-8" tabindex="-1">
                                        {{ $t('Nearest airport') }}
                                    </a>
                                </li>
                                <li v-for="airport in airports_data" class="fl-route-list ui-menu-item"
                                    @click="selectAirportOneway(airport)">
                                    <a class="fl-routes ui-menu-item-wrapper" tabindex="-1">
                                        <div class="inline-block airportMargin">
                                            <span class="fl-loc">
                                                {{ airport[this.$i18n.locale
                                                    + '_name'] }}
                                            </span>
                                            <span class="fl-country">
                                                {{ airport[this.$i18n.locale
                                                    + '_city'] }}
                                                ,
                                                {{ airport[this.$i18n.locale
                                                    + '_country'] }}
                                            </span>
                                        </div>
                                        <div class="pull-right">
                                            <h4 class="fl-route-code">{{
                                                airport.code }}
                                            </h4>
                                        </div>
                                    </a>
                                </li>
                                <li v-if="noResults" class="fl-route-list ui-menu-item no-results">
                                    {{ $t('No results!') }}
                                </li>
                            </ul>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                            <div class="form_search_date">
                                <div class="flight_Search_boxed">
                                    <div class="Journey_date">
                                        <p>{{ $t('Departure Date') }}</p>
                                        <VueDatePicker v-model="date" :enable-time-picker="false"
                                            :min-date="arrival_min_date" :max-date="arrival_max_date"
                                            @internal-model-change="handleInternal" :placeholder="$t('Departure Date')"
                                            :start-date="arrival_min_date" prevent-min-max-navigation />
                                        <span class="departure_day">
                                            {{ this.date ? $t(new
                                                Date(this.date).toLocaleDateString('en-US',
                                                    { weekday: 'long' })) : '' }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-1 col-md-6 col-sm-12 col-12 p-r-0">
                            <div class="flight_Search_boxed dropdown_passenger_area">
                                <p>{{ $t('Passengers') }}</p>
                                <div class="dropdown">
                                    <button class="dropdown-toggle final-count" type="button">
                                        {{ number }} {{ $t('passenger') }}
                                    </button>
                                </div>
                            </div>
                            <div v-if="guest_id && companions.length > 0 && is_self_paying == 0"
                                class="form-group check-companion">
                                <label class="form-check-label">
                                    <span class="area_flex_one">
                                        <div class="ripple-checkbox-primary">
                                            <input class="inp-cbx" id="booking-companion-2" type="checkbox"
                                                v-model="booking_for_companion" @change="handle_booking_for_companion"
                                                style="display: none">
                                            <label class="cbx" for="booking-companion-2">
                                                <span>
                                                    <svg width="12px" height="10px" viewBox="0 0 12 10">
                                                        <polyline points="1.5 6 4.5 9 10.5 1">
                                                        </polyline>
                                                    </svg>
                                                </span>
                                            </label>
                                        </div>
                                        <span class="p-0 pl-2 pr-2">
                                            {{ $t('booking for companion as well') }}
                                        </span>
                                    </span>
                                </label>
                            </div>
                        </div>
                        <div class="col-lg-1 col-md-6 col-sm-12 col-12 p-r-0 ">
                            <div class="flight_Search_boxed dropdown_passenger_area">
                                <p>{{ $t('Class') }} </p>
                                <div class="dropdown">
                                    <button v-if="allowedDegree.length > 1" class="dropdown-toggle final-count"
                                        data-toggle="dropdown" type="button" id="dropdownMenuButton1"
                                        data-bs-toggle="dropdown" aria-expanded="false">
                                        {{ $t(cabin) }}
                                    </button>
                                    <button v-else class="dropdown-toggle final-count" type="button">
                                        {{ $t(cabin) }}
                                    </button>
                                    <div v-if="allowedDegree.length > 1" class="dropdown-menu dropdown_passenger_info"
                                        aria-labelledby="dropdownMenuButton1">
                                        <div class="traveller-calulate-persons">
                                            <div class="cabin-selection">
                                                <h6>{{ $t('Cabin Class') }}
                                                </h6>
                                                <div class="cabin-list">
                                                    <button v-if="allowedDegree.includes('economy')" type="button"
                                                        class="label-select-btn">
                                                        <input id="ob-eco" type="radio" v-model="cabin" name="cabin"
                                                            value="ECONOMY" class="chk-cabin">
                                                        <label for="ob-eco">
                                                            <span class="muiButton-label">
                                                                {{
                                                                    $t('ECONOMY')
                                                                }}
                                                            </span>
                                                        </label>
                                                    </button>
                                                    <button v-if="allowedDegree.includes('business')" type="button"
                                                        class="label-select-btn">
                                                        <input id="ob-bus" type="radio" v-model="cabin" name="cabin"
                                                            value="BUSINESS" class="chk-cabin">
                                                        <label for="ob-bus">
                                                            <span class="muiButton-label">
                                                                {{
                                                                    $t('BUSINESS')
                                                                }}
                                                            </span>
                                                        </label>
                                                    </button>
                                                    <button v-if="allowedDegree.includes('first class')" type="button"
                                                        class="label-select-btn">
                                                        <input id="ob-firs" type="radio" v-model="cabin" name="cabin"
                                                            value="FIRST" class="chk-cabin">
                                                        <label for="ob-firs">
                                                            <span class="muiButton-label">
                                                                {{
                                                                    $t('FIRST')
                                                                }}
                                                            </span>
                                                        </label>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="top_form_search_button">
                        <button type="button" class="btn btn_theme btn_md btn-search-flight-next" @click="search">
                            {{ $t('Search Flight') }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import $ from 'jquery';
import { debounce } from 'lodash';
import { toast } from 'vue3-toastify';
import jsonData from '@/assets/file/airports-v2.json';
import { diffYears, formatStringDate } from '@/utils/dateUtils';

export default {
    name: "OneWaySearchForm",
    props: [
        'arrival_min_date',
        'arrival_max_date',
        'companions',
        'guest_id',
        'is_self_paying',
        'allowedDegree',
        'departure_start_date',
        'departure_end_date',
        'is_admin',
        'view'
    ],
    data() {
        return {
            is_searching: false,
            noResults: false,
            arrival: null,
            arrival_name: null,
            arrival_date: null,
            airports_data: [],
            cabin: 'ECONOMY',
            date: null,
            number: 1,
            pnumber: 1,
            cnumber: 0,
            inumber: 0,
            booking_for_companion: false,
            unique: true,
            cheapest: true,
            main_airport: {
                code: "RUH",
                ar_name: "مطار الملك خالد الدولي",
                en_name: "King Khalid Intl",
            },
        }
    },
    watch: {
        'allowedDegree': {
            handler() {
                var tripType = localStorage.getItem("tripType");
                if (this.view == 'result' && tripType == 'oneway') {
                    this.booking_for_companion = this.number > 1 ? true : false;
                    return;
                }
                if (this.allowedDegree.includes('business')) {
                    this.cabin = 'BUSINESS';
                } else if (this.allowedDegree.includes('economy')) {
                    this.cabin = 'ECONOMY';
                } else if (this.allowedDegree.includes('first class')) {
                    this.cabin = 'FIRST';
                }
            },
            deep: true
        },
        'companions': {
            handler() {
                if (this.is_self_paying == 1 || !this.guest_id) {
                    if (this.is_self_paying == 0) {
                        this.number = 0;
                        this.pnumber = 0;
                    }
                    this.companions.forEach(element => {
                        if (element.data_status == "Complete" && !element.flight) {
                            var dt1 = new Date(element.birthdate);
                            var dt2 = new Date();
                            var interval = this.diff_years(dt1, dt2);
                            if (interval <= 2) {
                                this.inumber += 1;
                            } else if (interval <= 11) {
                                this.cnumber += 1;
                            } else {
                                this.pnumber += 1;
                            }
                            this.number += 1;
                        }
                    });
                }
            },
            deep: true
        },
    },
    methods: {
        handleInternal(date) {
            const dateStr1 = date;
            const dateStr2 = this.date;
            const date1 = new Date(dateStr1);
            const date2 = new Date(dateStr2);
            if (date1 < date2 || date1 > date2) {
                setTimeout(() => {
                    $(document).find('.dp__action_select').click();
                }, 100);
            }
        },
        handle_airports_search_oneway: debounce(function (val) {
            this.searchAirPortsOneway(this.arrival);
        }, 500),
        searchAirPortsOneway(val) {
            this.noResults = false;
            if (val == '') {
                this.is_searching = false;
                return;
            } else {
                this.is_searching = true;
            }
            this.airports_data = jsonData.filter(item => {
                if (item.ar_name == null ||
                    item.code == null ||
                    item.ar_city == null ||
                    item.ar_state == null ||
                    item.ar_country == null ||
                    item.en_name == null ||
                    item.en_city == null ||
                    item.en_state == null ||
                    item.en_country == null) {
                    return false;
                } else {
                    return item.ar_name.toLowerCase().includes(val.toLowerCase()) ||
                        item.code.toLowerCase().includes(val.toLowerCase()) ||
                        item.ar_city.toLowerCase().includes(val.toLowerCase()) ||
                        item.ar_state.toLowerCase().includes(val.toLowerCase()) ||
                        item.ar_country.toLowerCase().includes(val.toLowerCase()) ||
                        item.en_name.toLowerCase().includes(val.toLowerCase()) ||
                        item.en_city.toLowerCase().includes(val.toLowerCase()) ||
                        item.en_state.toLowerCase().includes(val.toLowerCase()) ||
                        item.en_country.toLowerCase().includes(val.toLowerCase());
                }

            });
            if (this.airports_data.length == 0) {
                this.noResults = true;
            }
        },
        selectAirportOneway(data) {
            this.is_searching = false;
            this.arrival = data['code'];
            this.arrival_name = data[this.$i18n.locale + '_name'];
        },
        handle_booking_for_companion() {
            if (this.booking_for_companion) {
                this.companions.forEach(element => {
                    if (element.data_status != 'Complete' && !element.flight) {
                        this.number = 1;
                        this.booking_for_companion = false;
                        toast.error(this.$t('You have to complete your companion information'), {
                            autoClose: 3500,
                            position: toast.POSITION.TOP_CENTER,
                            closeButton: false
                        });
                        return;
                    } else if (element.data_status == "Complete" && !element.flight) {
                        var dt1 = new Date(element.birthdate);
                        var dt2 = new Date();
                        var interval = this.diff_years(dt1, dt2);
                        if (interval <= 2) {
                            this.inumber += 1;
                        } else if (interval <= 11) {
                            this.cnumber += 1;
                        } else {
                            this.pnumber += 1;
                        }
                        this.number += 1;
                    }
                });
            } else {
                this.number = 1;
                this.pnumber = 1;
                this.cnumber = 0;
                this.inumber = 0;
            }
        },
        diff_years(dt2, dt1) {
            return diffYears(dt2, dt1);
        },
        isDateBetween(dateToCheck, startDate, endDate) {
            return dateToCheck >= startDate && dateToCheck <= endDate;
        },
        format_date(inputDate) {
            return formatStringDate(inputDate);
        },
        formatDateSafari(date) {
            return new Date(String(date).replace(/undefined-undefined-/g, '').replace(/-/g, '/'));
        },
        search() {
            var from = this.main_airport.code,
                to = this.arrival,
                date = new Date(this.date).toLocaleDateString('sv-SE');
            const isDateBetween = this.isDateBetween(
                new Date(this.date).toLocaleDateString('sv-SE'),
                new Date(this.departure_start_date).toLocaleDateString('sv-SE'),
                new Date(this.departure_end_date).toLocaleDateString('sv-SE')
            );
            if (to == null || from == to) {
                toast.error(this.$t('Invalid Location'), {
                    autoClose: 3500,
                    position: toast.POSITION.TOP_CENTER,
                    closeButton: false
                });
            } else if (this.date == null) {
                toast.error(this.$t('Invalid Date'), {
                    autoClose: 3500,
                    position: toast.POSITION.TOP_CENTER,
                    closeButton: false
                });
            } else if (this.departure_time_condition && !isDateBetween) {
                toast.error(
                    this.$t('The date of departure from Riyadh must be between the dates')
                    + this.departure_start_date
                    + this.$t('And date')
                    + this.departure_end_date,
                    {
                        autoClose: 3500,
                        position: toast.POSITION.TOP_CENTER,
                        closeButton: false
                    });
            } else {
                var data = {
                    "from": from,
                    "to": to,
                    "date": date,
                    "ret_date": '',
                    "currency": 'SAR',
                    "adults": this.pnumber,
                    "children": this.cnumber,
                    "infants": this.inumber,
                    "cabin": this.cabin,
                    "type": 'oneway',
                    "unique": this.unique,
                    "cheapest": this.cheapest,
                };
                this.$emit('search', data);
            }
        }
    },
    mounted() {
        var searchData = JSON.parse(localStorage.getItem("searchData"));
        var tripType = localStorage.getItem("tripType");
        var is_self_paying = localStorage.getItem("is_self_paying");

        if (this.view == 'result' && tripType == 'oneway') {
            if (is_self_paying == 0) {
                this.pnumber = parseInt(searchData.adults);
                this.cnumber = parseInt(searchData.children);
                this.inumber = parseInt(searchData.infants);
                this.number = this.pnumber + this.cnumber + this.inumber;
            }
            this.cheapest = searchData.cheapest;
            this.unique = searchData.unique;
            this.cabin = searchData.cabin;

            this.date = this.formatDateSafari(this.format_date(searchData.date));
            var arrival = jsonData.filter(item => {
                return item.code.includes(searchData.to);
            })[0];
            this.arrival = arrival.code;
            this.arrival_name = arrival[this.$i18n.locale + '_name'];
        }
    }
};
</script>